import { ref } from 'vue';
import { useScriptTag, until } from '@vueuse/core';

export function useRecaptcha() {
  const isLoaded = ref(false);
  const recaptchaToken = ref('');

  const loadRecaptchaScript = () => {
    const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

    if (isLoaded.value || window.grecaptcha) {
      isLoaded.value = true;
      return;
    }

    if (!document.querySelector(`script[src*="recaptcha/enterprise.js"]`)) {
      window.recaptchaCallback = () => {
        isLoaded.value = true;
      };

      useScriptTag(`https://www.google.com/recaptcha/enterprise.js?render=${recaptchaSiteKey}&onload=recaptchaCallback`, () => {}, {
        async: true,
        defer: true,
      });
      injectRecaptchaStyles();
    }
  };

  const waitForRecaptcha = async () => {
    if (!isLoaded.value) {
      loadRecaptchaScript();
      await until(isLoaded).toBe(true);
    }
  };

  const executeRecaptcha = async (action: string) => {
    const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

    await waitForRecaptcha();
    try {
      recaptchaToken.value = await window.grecaptcha.enterprise.execute(recaptchaSiteKey, { action });
      return recaptchaToken.value;
    } catch (error) {
      console.error('reCAPTCHA error:', error);
      return '';
    }
  };

  return {
    isLoaded,
    recaptchaToken,
    executeRecaptcha,
  };
}

const injectRecaptchaStyles = () => {
  const style = document.createElement('style');
  style.innerHTML = `
    .grecaptcha-badge {
      visibility: hidden !important;
      pointer-events: none !important;
    }
  `;
  document.head.appendChild(style);
};
